export default __webpack_public_path__ + "static/media/close_upload_file.77ae9d90.svg";